// extracted by mini-css-extract-plugin
export default {"preview-wrapper":"preview-wrapper--ubTuG"};